import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import { StorageService } from 'src/shared/services/storage/storage.service';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import { API_URLS } from 'src/environments/env-routes';


@Injectable({
  providedIn: 'root'
})
export class UploadDocumentsService {

  public display: boolean;
  public actualParentId: string;
  public files: any[];

  constructor(private storage: StorageService, private http: HttpClient, private api: APIHelper) {
    this.display = false;
  }

  public async upload(files, parentId) {
    this.actualParentId = parentId;
    const fileList = await this.getAllFileEntries(files);
    const uploadPromisesList = fileList.map(file => {
      return this.uploadSingleFile(file, parentId, file.relativePath);
    });

    return Promise.all(uploadPromisesList);
  }

  public uploadBinary({file, method, url, parameters}: { file: any, method: string, url: string, parameters: object }): Promise<any> {
    const form = new FormData();
    form.append('filedata', file, file.name);

    for (const prop in parameters) {
      if (!parameters.hasOwnProperty(prop)) {
        continue;
      }

      form.append(prop, parameters[prop]);
    }

    const bearer = this.storage.getAsync({key: 'bearer'});
    let header = new HttpHeaders();
    header = header.set('Authorization', 'Basic ' + bearer);

    const req = new HttpRequest(method, url, form, {
      reportProgress: true,
      headers: header
    });
    return new Promise((resolve, reject) => {
      this.http.request(req).toPromise().then(request => {
        resolve(request);
      }).catch(reject);
    });
  }

  async getAllFileEntries(dataTransferItemList) {
    const fileEntries = [];
    const queue = [];
    dataTransferItemList = dataTransferItemList.items;
    for (let i = 0; i < dataTransferItemList.length; i++) {
      queue.push(dataTransferItemList[i].webkitGetAsEntry());
    }
    while (queue.length > 0) {
      const entry = queue.shift();
      if (entry.isFile) {
        await new Promise((resolve) => {
          entry.file(file => {

            /**
             * this to avoid creating an extra folder containing a file
             * example : contract.pdf => contract.pdf/contract.pdf
             * this relative path processing solves this problem
             */
            file.relativePath = entry.fullPath.split('/').slice(1, -1).join('/');
            fileEntries.push(file);
            resolve(file);
          });
        });

      } else if (entry.isDirectory) {
        const reader = entry.createReader();
        queue.push(...await this.readAllDirectoryEntries(reader));
      }
    }
    return Promise.all(fileEntries);
  }

  async readAllDirectoryEntries(directoryReader) {
    const entries = [];
    let readEntries: any = await this.readEntriesPromise(directoryReader);
    while (readEntries.length > 0) {
      entries.push(...readEntries);
      try {
        readEntries = await this.readEntriesPromise(directoryReader);
      } catch (e) {
        console.error(e);
      }
    }
    return entries;
  }

  async readEntriesPromise(directoryReader) {
    try {
      return await new Promise((resolve, reject) => {
        directoryReader.readEntries(resolve, reject);
      });
    } catch (err) {
      console.error(err);
    }
  }

  public uploadSingleFile(file, parentId: string, relativePath: string = '', autoRename: boolean = true) {
    const base_url = this.api.url + API_URLS.nodes.children.replace(':nodeId', parentId);
    const params = '?autoRename=true&include=allowableOperations';
    const url = base_url + params;

    const parameters = {
      'relativePath': relativePath,
      'renditions': 'doclib',
      'include': 'allowableOperations',
      'autoRename': autoRename,
      'nodeType': 'cm:content'
    };

    return this.uploadBinary({file, method: 'POST', url, parameters});
  }

  public uploadSingleFileNewVersion(file, id: string) {
    // const base_url = this.api.url + API_URLS.nodes.versionContent.replace(':nodeId', id);
    // const params = '';
    // const url = base_url + params;
    //
    // const parameters = {
    //   'relativePath': '',
    //   'renditions': 'doclib',
    //   'include': 'allowableOperations',
    //   'nodeType': 'cm:content'
    // };

    //return this.http.put(url, file).toPromise();
    const endpoint = API_URLS.nodes.versionContent.replace(':nodeId', id);
    return this.api.requestApi({action: endpoint, method: 'PUT', datas: file});
  }

}
